export default __webpack_public_path__ + "static/media/nextjs.8a26c6f6.svg";